module.exports = __webpack_public_path__ + "static/media/028-girl-16.bfae8f0d.svg";